// Browser entry: design system first, then the store and the app shell.
import './styles/base.css';
import { render } from 'preact';
import { initStore } from './store.js';
import { App } from './app.jsx';

initStore();
render(<App />, document.getElementById('app'));
